module.exports = __webpack_public_path__ + "static/img/roof.23fdd3d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/roof.gif
// module id = 04wi
// module chunks = 0